
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fwa",
      function () {
        return require("private-next-pages/fwa.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fwa"])
      });
    }
  